import { render, staticRenderFns } from "./SubcommissionAllocation.vue?vue&type=template&id=1cd91dae&scoped=true"
import script from "./SubcommissionAllocation.vue?vue&type=script&lang=js"
export * from "./SubcommissionAllocation.vue?vue&type=script&lang=js"
import style0 from "./SubcommissionAllocation.vue?vue&type=style&index=0&id=1cd91dae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd91dae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cd91dae')) {
      api.createRecord('1cd91dae', component.options)
    } else {
      api.reload('1cd91dae', component.options)
    }
    module.hot.accept("./SubcommissionAllocation.vue?vue&type=template&id=1cd91dae&scoped=true", function () {
      api.rerender('1cd91dae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hierarchicalCommissionAllocation/RankCommission/components/SubcommissionAllocation.vue"
export default component.exports